import { render, staticRenderFns } from "./PostFeed.vue?vue&type=template&id=5d96257c"
import script from "./PostFeed.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostFeed.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CreatorShopPostFeedItem: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/creator-shop/post-feed/PostFeedItem.vue').default,LtkList: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Ltk/LtkList.vue').default})
